// The URL generated by the API does not have sufficient information in it to be saved correctly by the Mason BE. The include type parameters (e.g newHomes=include, include_retirement_homes=true) need to be added to the URL if not present, otherwise the BE adds them in with their Mason default values which are always false.
export const saveSearchAndAlertUrlFixer = (url?: string | null) => {
    if (!url) {
        return null;
    }

    const pathAndQuery = url.split('?');
    const queryParams = pathAndQuery[1].split('&');
    const queryParamsToAdd = [];

    if (!queryParams.find((qp) => qp.indexOf('new_homes') > -1)) {
        queryParamsToAdd.push('new_homes=include');
    }
    if (
        !queryParams.find((qp) => qp.indexOf('include_retirement_homes') > -1)
    ) {
        queryParamsToAdd.push('include_retirement_homes=true');
    }
    if (
        !queryParams.find((qp) => qp.indexOf('include_shared_ownership') > -1)
    ) {
        queryParamsToAdd.push('include_shared_ownership=true');
    }
    if (
        !queryParams.find(
            (qp) => qp.indexOf('include_shared_accommodation') > -1
        )
    ) {
        queryParamsToAdd.push('include_shared_accommodation=true');
    }

    return `${pathAndQuery[0]}?${queryParamsToAdd.join('&')}&${queryParams.join(
        '&'
    )}`;
};
